import { IFetchAuctionResultsAction } from ".";
import { ofType } from "redux-observable";
import { ResultsActionEnum } from ".";
import { AuctionService, IProductResult } from "../../services";
import { catchError, map, mergeMap, of, withLatestFrom } from "rxjs";
import { IApplicationState } from "..";
import { FetchAuctionResultsFailedAction } from "./ActionCreator";
import { FetchAuctionResultsSuccessAction } from "./ActionCreator";

const auctionService = new AuctionService();

export const fetchAuctionResultsEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(ResultsActionEnum.FetchAuctionResults),
    withLatestFrom(state$),
    mergeMap(([action, state]: [IFetchAuctionResultsAction, IApplicationState]) => {
      return auctionService.getAuctionResults(action.state?.identification!).pipe(
        map((results: IProductResult[]) => {
          return FetchAuctionResultsSuccessAction(results);
        }),
        catchError((error: any) => {
          return of(FetchAuctionResultsFailedAction(error.message));
        })
      );
    })
  );
